import { Injectable } from '@angular/core';
import { StockageService } from '../stockage/stockage.service';
import { IContext } from '../../models/context';
import { Role } from '../../models/role';

@Injectable({
  providedIn: 'root',
})
export class ContextService {
  constructor(private readonly stockageService: StockageService) {}

  /**
   * Récupère le login de l'utilisateur connecté.
   *
   * @returns {string | undefined}
   */
  get currentLogin(): string | undefined {
    return this.getContext()?.username;
  }

  /**
   * Obtient les rôles actuels de l'utilisateur.
   *
   * Les rôles sont définis comme suit :
   * - 3: Administrateur
   * - 4: Notaire
   * - 5: Collaborateur avec accès complet
   *
   * @returns {string[] | undefined} - Tableau de chaînes représentant les rôles actuels de l'utilisateur.
   */
  get currentUserRoles(): string[] {
    const roles = this.getContext()?.roles;
    return roles ? Object.values(roles) : [];
  }

  /**
   * Indique si l'utilisateur actuel est un administrateur.
   *
   * @returns {boolean}
   */
  get isNotaire(): boolean {
    return this.currentUserRoles.includes(Role.NOTARY);
  }

  public getContext(): IContext | null {
    const jwt = this.stockageService.getItem('X-Perval-Context');
    if (jwt) {
      const payload = JSON.parse(atob(jwt.split('.')[1]));
      const context: IContext = {
        username: payload.username,
        crpcen: payload.office.numero,
        roles: payload.roles,
      };
      return context;
    }
    return null;
  }
}
